<template>
  <div class="registerWrap">
<!--    v-if="isRegister != 1"-->
    <router-link v-if="isLogin != 1" :to="{path:'/login', query:{isStatus:1}}"><el-button style="font-size:16px" type="text">注册</el-button></router-link>
    <div class="header-right">
      <!--            v-if="isLogin == 1"-->
      <div class="header-user-con">
        <!--</div>-->
        <!-- 用户头像 -->
        <div class="user-avator">
<!--          <img v-if="isLogin == 2" src="@/assets/img/notLoggedIn.png">-->
          <img v-if="isLogin == 1" src="@/assets/img/signedIn.png">
        </div>
        <!-- 用户名下拉菜单 -->
<!--        v-if="isLogin == 2"-->
        <router-link v-if="isLogin != 1" :to="{path:'/login', query:{isStatus:2}}"><el-button style="margin-left:10px;font-size:16px" type="text">登录</el-button></router-link>
<!--        trigger="click"-->
        <el-dropdown v-if="isLogin == 1" class="user-name" @command="handleCommand">
                    <span class="el-dropdown-link">
                      {{ userName }} <i class="el-icon-caret-bottom"></i>
                    </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "registerModule",
  inject:[
    'reload'
  ],
  data() {
    return {
      // isStatus:1, //1表示注册 2表示登录
      isLogin:localStorage.getItem('isLogin'),
      isRegister:localStorage.getItem('isRegister'),
      userName:localStorage.getItem('userName')
    }
  },
  methods: {
    // 用户名下拉菜单选择事件
    //退出登录
    handleCommand(command) {
      if(command == 'loginout'){
        localStorage.setItem('isLogin', 2); //1登录 2未登录

        console.log('显示登录状态')
        console.log(localStorage.getItem('isLogin'));

        this.update();
        // this.$router.go(0)
      }
    },
    update(){
      this.reload()
      console.log('刷新页面')
    }
  },
  mounted() {
    console.log(localStorage.getItem('userName'));
    console.log(localStorage.getItem('isRegister'));
    console.log(localStorage.getItem('userPass'));
  }
}
</script>

<style scoped>
.registerWrap{
  display: flex;
  justify-content: center;
  align-items: center;
}
.header-right{
  float: right;
  padding-right: 50px;
}
.header-user-con{
  display: flex;
  height: 70px;
  align-items: center;
}
.btn-fullscreen{
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}
.btn-bell, .btn-fullscreen{
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}
.btn-bell-badge{
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}
.btn-bell .el-icon-bell{
  color: #fff;
}
.user-name{
  margin-left: 10px;
}
.user-avator{
  margin-left: 20px;
}
.user-avator img{
  display: block;
  width:40px;
  height:40px;
  border-radius: 50%;
}
.el-dropdown-link{
  color:#221815;
  cursor: pointer;
}
.el-dropdown-menu__item{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/registerModule.vue